module.exports = __webpack_public_path__ + "img/non-variceal-bleeding.d4501241.jpg";